import script from "./MoleculeCarousel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeCarousel.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeCarousel.vue?vue&type=style&index=0&id=464184ff&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464184ff"]])

export default __exports__